export default __webpack_public_path__ + "static/assets/981b2143ad7923419ae9a9474fee9216.png";